import { Component, Injector, OnInit } from "@angular/core";
import { accountModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import { AccountServiceProxy, ForgotPasswordInput } from "@shared/service-proxies/service-proxies";
import { ForgotPasswordSmsCodeDialogComponent } from "account/forgot-password-sms-code/forgot-password-sms-code-dialog.component";
import * as moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { finalize } from "rxjs/operators";

@Component({
  templateUrl: "./forgot-password-dialog.component.html",
  animations: [accountModuleAnimation()],
})
export class ForgotPasswordDialogComponent extends AppComponentBase implements OnInit {
  model = new ForgotPasswordInput();
  tenancyName: string = '';
  saving: boolean;

  constructor(
    injector: Injector,
    private _accountService: AccountServiceProxy,
    public bsModalRef: BsModalRef,
    private _modalService: BsModalService,
  ) {
    super(injector);
  }

  ngOnInit() {}

  resetPassword() {
    abp.ui.setBusy();
    this.saving = true;
    this.model.tenancyName = this.tenancyName;
    this.model.expirationDate = moment();
    this.model.cpfCnpj = this.model.cpfCnpj.replace(/\D/g, '');
    this._accountService
      .forgotPassword(this.model)
      .pipe(
        finalize(() => {
          this.saving = false;
          abp.ui.clearBusy();
        })
      )
      .subscribe((retorno) => {
        if (retorno.success && !retorno.isPaciente) {
          this.bsModalRef.hide();
          abp.message.success(this.l("VerifyEmailRecoverPassword"), this.l('Success'));
        }

        if (retorno.success && retorno.isPaciente) {
          this.bsModalRef.hide();
          this._modalService.show(ForgotPasswordSmsCodeDialogComponent, {
          class: 'modal-md modal-aviso-central',
          initialState: {
            dataHora: this.model.expirationDate,
            cpf: this.model.cpfCnpj,
            tenancyName: this.model.tenancyName
          }
        });
        }

      });
  }

}
